import { apiClient } from "helpers/api_helper";
import { API } from "../constant/return.sales.api";

export const getReturnSalesOrdersListData = async (data: object) => {
    try {
        const response = await apiClient.get(API.GET_RETURN_SALES_ORDERS, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getReturnSalesOrderItemsListData = async (returnSalesOrderId: any) => {
    try {
        const response = await apiClient.get(API.GET_RETURN_SALES_ORDER_ITEMS, { returnSalesOrderId });
        return response;
    }
    catch (error: any) {
        throw new Error(error);
    }
}

export const calculateReturnSalesOrderItemPrices = async (data: object) => {
    try {
        const response = await apiClient.post(API.CALCULATE_RETURN_SALES_ORDER_ITEM_PRICES, data);
        return response;
    }
    catch (error: any) {
        throw new Error(error);
    }
}

export const completeReturnSalesOrderQC = async (data: object) => {
    try {
        const response = await apiClient.post(API.COMPLETE_RETURN_SALES_ORDER_QC, data);
        return response;
    }
    catch (error: any) {
        throw new Error(error);
    }
}

export const rejectReturnSalesOrderItemQC = async (data: object) => {
    try {
        const response = await apiClient.post(API.REJECT_RETURN_SALES_ORDER_ITEM_QC, data);
        return response;
    }
    catch (error: any) {
        throw new Error(error);
    }
}